if (window.rt_bridge) {
  //log.debug('Found bridge.');
} else {
  console.error('Did not find bridge!');
}
window.rt_bridge = window.rt_bridge || {};
window.rt_bridge.page_data = window.rt_bridge_page_data || {};
export default window.rt_bridge;
